<div class="view-container user-card">
  <div class="view user-card-container">
    <div class="user-card-header">
      <div class="user-card-header-actions">
        <h1 class="page-header">
          <i
            [appTooltip]="'library.user_card.view.header.user_blocked' | translate"
            [hidden]="!user?.locked"
            class="icon-block-user-icon user-blocked-icon"
          ></i>
          <app-ellipsis>{{ user?.getDisplayName() }}</app-ellipsis>
        </h1>
        <h1 class="user-card-header-mobile">
          <i
            [appTooltip]="'library.user_card.view.header.user_blocked' | translate"
            [hidden]="!user?.locked"
            class="icon-block-user-icon user-blocked-icon"
          ></i>
          {{ user?.getDisplayName() }}
        </h1>
      </div>
    </div>
    <div class="user-card-content">
      <div class="user-card-attributes-container">
        <ui-attribute>
          <ng-template appTemplate="name">
            {{ 'library.user_card.attributes.display_name.option.labels' | translate }}
          </ng-template>
          <ng-template appTemplate="value">
            @if (user.labels.length > 0) {
              <lib-limited-items [items]="user.labels">
                <ng-template
                  appTemplate="item"
                  let-label
                >
                  <lib-label-display-item [label]="label"></lib-label-display-item>
                </ng-template>
              </lib-limited-items>
            }
            @if (user.labels.length === 0) {
              {{ 'common.empty' | translate }}
            }
          </ng-template>
        </ui-attribute>
        @for (attribute of attributes; track attribute) {
          <ui-attribute>
            <ng-template appTemplate="name">
              {{ attribute.displayNameKey | translate }}
            </ng-template>
            <ng-template appTemplate="value">
              {{ attribute.value ? attribute.value : ('common.empty' | translate) }}
            </ng-template>
          </ui-attribute>
        }
      </div>
    </div>
  </div>
</div>
